
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/resources/[slug]",
      function () {
        return require("private-next-pages/resources/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/resources/[slug]"])
      });
    }
  